/*  Release 3.2 - 1.1 - Starts */
import React, { useState, useRef, useEffect } from "react";
import { apolloClient, apolloProxyClient } from "../../../index";
import { useMutation } from "@apollo/react-hooks";
import { Ring } from "react-awesome-spinners";
import { connect } from "react-redux";
import {
  FormButton,
  FormButtonsWrap,
  LoaderWrap,
  DescriptionInput,
  Select,
} from "../..";
import { pushMessage } from "../../../actions";
import {
  bgOrganizations,
  updateBEABudget,
  organizationBEABudget,
} from "../../../graphql";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

const EditBEABudget = (props) => {
  const { hideModal, modal, pushMessage, account } = props;
  const proxyCheck = sessionStorage.getItem("proxy_access");
  const httpClient = proxyCheck == null ? apolloClient : apolloProxyClient;
  const { roles, accessibles } = account;
  const isBCB = roles.includes("bcb");
  const [popUpAction, setPopUpAction] = useState("Edit");
  const [messages, setMessages] = useState([]);
  const [messageType, setMessageType] = useState("error");
  const selectedBudgetdata = modal.modalContent;
  const [budgetId, setBudgetId] = useState(null);
  const [selectedyear, setSelectedYear] = useState("");
  const [selectedOrg, setSelectedOrg] = useState("");
  const [capitalBudget, setCapitalBudget] = useState(0.0);
  const [budget, setBudget] = useState(0.0);
  const [budgetInProgress, setBudgetInProgress] = useState(0.0);
  const [budgetSpent, setBudgetSpent] = useState(0.0);
  const [budgetForecast, setBudgetForecast] = useState(0.0);
  const [budgetAvailable, setBudgetAvailable] = useState(0.0);
  const [requestDescription, setRequestDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const capitalInput = useRef(null);
  const budgetInput = useRef(null);
  const [allOrgs, setAllOrgs] = useState([]);
  const [editBEABudget] = useMutation(updateBEABudget);

  useEffect(() => {
    getBGOrganization().then((resultBGOrganization) => {
      if (resultBGOrganization) {
        const filteredOrgArray = isBCB
          ? resultBGOrganization.filter((item) =>
              accessibles.budgetOrgs ? accessibles.budgetOrgs.includes(item.organization_unit) : false
            )
          : resultBGOrganization;
        setAllOrgs(
          filteredOrgArray
            ? filteredOrgArray.map((a) => ({
                organization_unit_name: a.organization_unit_name,
                organization_unit: a.organization_unit,
              }))
            : []
        );
      }
    });
    if (selectedBudgetdata) {
      setBudgetId(selectedBudgetdata.budget_id);
      setSelectedOrg(selectedBudgetdata.organization_unit);
      setSelectedYear(selectedBudgetdata.year);
      setCapitalBudget(selectedBudgetdata.capital_budget);
      setBudget(selectedBudgetdata.budget);
      setBudgetForecast(
        selectedBudgetdata.budget
          ? (
              selectedBudgetdata.budget -
              ((selectedBudgetdata.budget_in_progress
                ? selectedBudgetdata.budget_in_progress
                : 0) +
                (selectedBudgetdata.budget_spent
                  ? selectedBudgetdata.budget_spent
                  : 0))
            )
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          : 0
      );
      setBudgetAvailable(
        selectedBudgetdata.budget
          ? (
              selectedBudgetdata.budget -
              (selectedBudgetdata.budget_spent
                ? selectedBudgetdata.budget_spent
                : 0)
            )
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          : 0
      );
      setBudgetInProgress(
        selectedBudgetdata.budget_in_progress
          ? selectedBudgetdata.budget_in_progress
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          : 0
      );
      setBudgetSpent(
        selectedBudgetdata.budget_spent
          ? selectedBudgetdata.budget_spent
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          : 0
      );
      setRequestDescription(selectedBudgetdata.description);
      capitalInput.current.value = selectedBudgetdata.capital_budget
        ? "€ " +
          selectedBudgetdata.capital_budget
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        : "€ 0";
      budgetInput.current.value = selectedBudgetdata.budget
        ? "€ " +
          selectedBudgetdata.budget
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        : "€ 0";
    }
  }, [selectedBudgetdata]);

  const getBGOrganization = async () => {
    return await new Promise((resolve) => {
      httpClient
        .query({
          query: bgOrganizations,
          variables: {},
        })
        .then((response) => {
          if (response.data && response.data.bgOrganizations) {
            resolve(response.data.bgOrganizations);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  };

  const parentDiv = {
    width: "80%",
    padding: "2px",
    margin: "0 auto",
  };
  const rowStyle = {
    width: "100%",
    display: "flex",
  };
  const columnQuarterStyle = {
    fontSize: "15px",
    fontWeight: "400",
    width: "25%",
    float: "left",
    margin: "10px",
  };
  const columnHalfStyle = {
    fontSize: "15px",
    fontWeight: "400",
    width: "50%",
    float: "left",
    margin: "10px",
  };
  const columnFullStyle = {
    fontSize: "15px",
    fontWeight: "400",
    width: "100%",
    float: "left",
    margin: "10px",
  };
  const columnHeaderStyle = {
    fontSize: "20px",
    fontWeight: "400",
    width: "100%",
    textAlign: "center",
    margin: "10px",
  };
  const columnButtonStyle = {
    width: "50%",
    float: "left",
    margin: "0 10px !important",
  };

  function formatNumber(n) {
    return n
      .toString()
      .replace(/[^0-9.]/g, "") //.replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatCurrency(input_val, event) {
    //console.log("input_val : " + input_val);
    if (input_val === "") {
      return;
    }

    if (event.target.id == "new_budget" && capitalInput.current.value == "") {
      setMessages(["Please enter capital budget."]);
      setMessageType("error");
      budgetInput.current.value = "";
      return;
    }

    let capitalBudgetInputVal = 0;
    let budgetInputVal = 0;
    let budgetInprogressInputVal = 0;
    let budgetSpentInputVal = 0;

    if (event.target.id == "new_capital") {
      capitalBudgetInputVal = parseFloat(
        input_val.replaceAll("€", "").replaceAll(",", "").replaceAll(" ", "")
      );
    } else {
      capitalBudgetInputVal = parseFloat(
        capitalInput.current.value
          .toString()
          .replaceAll("€", "")
          .replaceAll(",", "")
          .replaceAll(" ", "")
      );
    }
    if (event.target.id == "new_budget") {
      budgetInputVal = parseFloat(
        input_val.replaceAll("€", "").replaceAll(",", "").replaceAll(" ", "")
      );
    } else {
      budgetInputVal = parseFloat(
        budgetInput.current.value
          .toString()
          .replaceAll("€", "")
          .replaceAll(",", "")
          .replaceAll(" ", "")
      );
    }

    budgetInprogressInputVal = parseFloat(
      budgetInProgress
        .toString()
        .replaceAll("€", "")
        .replaceAll(",", "")
        .replaceAll(" ", "")
    );
    budgetSpentInputVal = parseFloat(
      budgetSpent
        .toString()
        .replaceAll("€", "")
        .replaceAll(",", "")
        .replaceAll(" ", "")
    );

    // console.log("capitalBudgetInputVal : " + capitalBudgetInputVal);
    // console.log("budgetInputVal : " + budgetInputVal);
    // console.log("budgetInprogressInputVal : " + budgetInprogressInputVal);
    // console.log("budgetSpentInputVal : " + budgetSpentInputVal);
    // console.log(
    //   "budgetForecast : " +
    //     (budgetInputVal - (budgetInprogressInputVal + budgetSpentInputVal))
    // );
    // console.log(
    //   "budgetAvailable : " +
    //     (budgetInputVal - budgetSpentInputVal)
    // );

    if (event.target.id == "new_capital") {
      if (budgetInputVal > capitalBudgetInputVal) {
        setMessages(["Capital budget must be greater than the budget."]);
        setMessageType("error");
        input_val = parseFloat(capitalBudget);
      } else if (
        budgetInprogressInputVal + budgetSpentInputVal >
        capitalBudgetInputVal
      ) {
        setMessages([
          "Capital budget must be greater than the budget inprogress and spent.",
        ]);
        setMessageType("error");
        input_val = parseFloat(budget);
      }
      // setCapitalBudget(input_val);
    }
    if (event.target.id == "new_budget") {
      if (budgetInputVal > capitalBudgetInputVal) {
        setMessages(["Budget must be lesser than the capital budget."]);
        setMessageType("error");
        input_val = parseFloat(budget);
        budgetInputVal = parseFloat(
          input_val
            .toString()
            .replaceAll("€", "")
            .replaceAll(",", "")
            .replaceAll(" ", "")
        );
      } else if (
        budgetInprogressInputVal + budgetSpentInputVal >
        budgetInputVal
      ) {
        setMessages([
          "Budget must be greater than the budget inprogress and spent.",
        ]);
        setMessageType("error");
        input_val = parseFloat(budget);
        budgetInputVal = parseFloat(
          input_val
            .toString()
            .replaceAll("€", "")
            .replaceAll(",", "")
            .replaceAll(" ", "")
        );
      }
      // setBudget(input_val);
      setBudgetForecast(
        formatNumber(
          parseFloat(
            budgetInputVal - (budgetInprogressInputVal + budgetSpentInputVal)
          ).toFixed(2)
        )
      );
      setBudgetAvailable(
        formatNumber(
          parseFloat(budgetInputVal - budgetSpentInputVal).toFixed(2)
        )
      );
    }

    event.target.value =
      "€ " +
      formatNumber(
        parseFloat(
          input_val
            .toString()
            .replaceAll("€", "")
            .replaceAll(",", "")
            .replaceAll(" ", "")
        ).toFixed(2)
      );
  }

  const handleDescriptionChange = (event) => {
    setRequestDescription(event.target.value);
  };

  const handleQuit = () => {
    hideModal();
  };

  const handleCurrencyBlur = (e) => {
    formatCurrency(e.target.value, e);
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      let capitalBudgetInputVal = parseFloat(
        capitalInput.current.value
          ? capitalInput.current.value
              .toString()
              .replaceAll("€", "")
              .replaceAll(",", "")
              .replaceAll(" ", "")
          : 0
      );
      let budgetInputVal = parseFloat(
        budgetInput.current.value
          ? budgetInput.current.value
              .toString()
              .replaceAll("€", "")
              .replaceAll(",", "")
              .replaceAll(" ", "")
          : 0
      );
      let budgetInprogressInputVal = parseFloat(budgetInProgress);
      let budgetSpentInputVal = parseFloat(budgetSpent);
      if (!selectedOrg) {
        setMessages(["Organisation is required."]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }
      if (capitalBudgetInputVal == 0) {
        setMessages(["Capital budget is required."]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }
      if (budgetInputVal == 0) {
        setMessages(["Budget should is required."]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }
      if (budgetInputVal > capitalBudgetInputVal) {
        setMessages(["Budget should be lesser than capital budget."]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }
      if (budgetInprogressInputVal + budgetSpentInputVal > budgetInputVal) {
        setMessages([
          "Budget should be greater than sum of budget inprogress and spent.",
        ]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }
      if (!requestDescription || requestDescription.replaceAll(" ", "") == "") {
        setMessages(["Description is required."]);
        setMessageType("error");
        setIsSubmitting(false);
        return;
      }

      const results = await editBEABudget({
        variables: {
          budget_id: parseInt(budgetId),
          data: {
            description: requestDescription,
            budget: budgetInputVal,
            capital_budget: capitalBudgetInputVal,
            budget_available:
              budgetInputVal - budgetInprogressInputVal - budgetSpentInputVal,
            budget_in_progress: budgetInprogressInputVal,
            budget_spent: budgetSpentInputVal,
            year: selectedyear.toString(),
            organization_unit: selectedOrg.toString(),
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: organizationBEABudget,
            variables: {
              where: { year: { eq: selectedyear.toString() } },
            },
          },
        ],
      });
      if (results) {
        setIsSubmitting(false);
        hideModal();
        pushMessage({
          type: "success",
          message: "Budget details updated successfully!",
        });
      }
    } catch (e) {
      console.log("Graph QL error: " + e.message);
      setMessages("Issue in eaditing the budget." + e.message);
      setMessageType("error");
      setIsSubmitting(false);
    }
  };

  const MessageComponent = (props) => {
    return (
      <>
        <FontAwesomeIcon
          icon={
            props.type === "error"
              ? faTimesCircle
              : props.type === "info"
              ? faInfoCircle
              : faCheck
          }
          style={{
            marginRight: "10px",
          }}
        />
        {props.err}
        <br />
      </>
    );
  };

  const NotificationMassages = (props) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        setMessages([]);
        setMessageType("error");
      }, 6000);
      return () => clearTimeout(timer);
    }, []);
    return (
      <>
        {props.messages && props.messages.length > 0 && (
          <div
            key={Math.random()}
            style={{
              border: "1px solid",
              margin: "10px 0px",
              padding: "15px 10px 15px 50px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "10px center",
              color:
                props.type === "error"
                  ? "#D8000C"
                  : props.type === "info"
                  ? "#31708f"
                  : "#4F8A10",
              backgroundColor:
                props.type === "error"
                  ? "#FFBABA"
                  : props.type === "info"
                  ? "#d9edf7"
                  : "#DFF2BF",
            }}
          >
            {props.messages.map((err) => {
              {
                return <MessageComponent type={props.type} err={err} />;
              }
            })}
          </div>
        )}
      </>
    );
  };
  return (
    <div style={parentDiv}>
      <div style={rowStyle}>
        <div style={columnHeaderStyle}>
          <input id="searchResult" style={{ display: "none" }} />
          {popUpAction} Business Excellence Award Budget
        </div>
      </div>
      <NotificationMassages
        key={Math.random()}
        messages={messages}
        type={messageType}
      />
      <div style={rowStyle}>
        <div style={columnHalfStyle}>
          <div>Year</div>
          <div>{selectedyear}</div>
        </div>
        <div style={columnHalfStyle}>
          <div>
            Organisation Unit <span style={{ color: "red" }}>*</span>
          </div>
          <div>
            <Select
              disabled={true}
              style={{ marginLeft: "0px" }}
              value={selectedOrg}
            >
              {allOrgs &&
                allOrgs.length > 0 &&
                allOrgs.map((item) => {
                  return (
                    <option
                      key={item.organization_unit}
                      value={item.organization_unit}
                    >
                      {item.organization_unit_name}
                    </option>
                  );
                })}
            </Select>
            <div></div>
          </div>
        </div>
      </div>
      <div style={rowStyle}>
        <div style={columnHalfStyle}>
          <div>
            Capital Budget <span style={{ color: "red" }}>*</span>
          </div>
          <div>
            <input
              id="new_capital"
              ref={capitalInput}
              type="text"
              style={{ height: "2rem", width: "100%" }}
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              placeholder="&#8364;"
              disabled={true}
              // onKeyUp={handleCurrencyKeyUp}
              onBlur={handleCurrencyBlur}
            />
          </div>
        </div>
        <div style={columnHalfStyle}>
          <div>
            Budget <span style={{ color: "red" }}>*</span>
          </div>
          <div>
            <input
              id="new_budget"
              ref={budgetInput}
              type="text"
              style={{ height: "2rem", width: "100%" }}
              pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
              placeholder="&#8364;"
              // onKeyUp={handleCurrencyKeyUp}
              onBlur={handleCurrencyBlur}
            />
          </div>
        </div>
      </div>
      <div style={rowStyle}>
        <div style={columnQuarterStyle}>
          <div>Budget Spent</div>
          <div>
            <label>&#8364; {budgetSpent}</label>
          </div>
        </div>
        <div style={columnQuarterStyle}>
          <div>Budget In Progress</div>
          <div>
            <label>&#8364; {budgetInProgress}</label>
          </div>
        </div>
        <div style={columnQuarterStyle}>
          <div>Budget Forecast</div>
          <div>
            <label>&#8364; {budgetForecast ? budgetForecast : 0}</label>
          </div>
        </div>
        <div style={columnQuarterStyle}>
          <div>Budget Available</div>
          <div>
            <label>&#8364; {budgetAvailable ? budgetAvailable : 0}</label>
          </div>
        </div>
      </div>
      <div style={rowStyle}>
        <div style={columnFullStyle}>
          <div>
            Budget description <span style={{ color: "red" }}>*</span>
          </div>
          <div>
            <DescriptionInput
              style={{ width: "100%", height: "auto" }}
              name="request_description"
              onChange={handleDescriptionChange}
              defaultValue={requestDescription}
            />
          </div>
        </div>
      </div>
      <div style={rowStyle}>
        <div style={columnButtonStyle}>
          <FormButtonsWrap style={{ width: "100%", marginTop: "0px" }}>
            <FormButton onClick={handleQuit}>Quit</FormButton>
            <FormButton primary disabled={isSubmitting} onClick={handleSubmit}>
              {popUpAction === "Add" ? "Submit" : "Update"}
            </FormButton>
            {isSubmitting && (
              <LoaderWrap>
                <Ring color={"#001235"} size="2" sizeUnit="rem" />
              </LoaderWrap>
            )}
          </FormButtonsWrap>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { pushMessage })(EditBEABudget);
/*  Release 3.2 - 1.1 - Ends */
